import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import permission from './permission'
import user from './user'
import notification from './notification'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    permission,
    user,
    notification
  },
  strict: process.env.DEV,
})
